
import React from 'react';
import Layout from '@/components/Layout/Layout';
import BMRCalculator from '@/components/SpecialCalculators/HealthCalculators/BMRCalculator';

const BMRCalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">BMR Calculator</h1>
        <p className="text-gray-600 mb-8">
          Calculate your Basal Metabolic Rate and Total Daily Energy Expenditure.
        </p>
        
        <BMRCalculator />
        
        <div className="mt-12 p-6 bg-blue-50 rounded-lg">
          <h2 className="text-xl font-bold mb-2">About BMR Calculator</h2>
          <p className="text-gray-700 mb-4">
            The Basal Metabolic Rate (BMR) calculator helps you understand how many calories your body needs at rest to maintain basic functions. This calculator offers three different formulas:
          </p>
          <ul className="list-disc pl-6 space-y-1 text-gray-700">
            <li><strong>Mifflin-St Jeor:</strong> Generally considered the most accurate formula for most people</li>
            <li><strong>Harris-Benedict:</strong> A classic formula, revised in 1984</li>
            <li><strong>Katch-McArdle:</strong> Takes lean body mass into account, making it ideal for athletes</li>
          </ul>
          <p className="mt-4 text-gray-700">
            Understanding your BMR can help you set accurate calorie targets for weight loss, maintenance, or weight gain.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default BMRCalculatorPage;
